
import * as yup from 'yup';

const readImageSize = (file: File): Promise<{ width: number; height: number }> =>
  new Promise((resolve, reject) => {
    const url = URL.createObjectURL(file);
    const img = new Image();
    img.onload = () => {
      const out = { width: img.naturalWidth, height: img.naturalHeight };
      URL.revokeObjectURL(url);
      resolve(out);
    };
    img.onerror = (e) => {
    //  URL.revokeObjectURL(url);
      reject(new Error('Não foi possível ler a imagem.'));
    };
    img.src = url;
  });

const extOf = (file?: File | null) =>
  (file?.name?.split('.').pop() || '').toLowerCase();

const isOneOf = (value: string | undefined, list: string[]) =>
  !!value && list.includes(value);


const LOGO_EXTS = ['png', 'jpg', 'jpeg', 'svg'];
const BG_EXTS = ['png', 'jpg', 'jpeg'];
const ICO_ONLY = ['ico'];

export const UploadImagesFormValidation = yup.object({
  type: yup
    .mixed<'favicon' | 'logo' | 'background'>()
    .oneOf(['favicon', 'logo', 'background'])
    .required('Tipo é obrigatório.'),

//   title: yup.string().nullable(),
//   description: yup.string().nullable(),
  acceptedFormats: yup.string(),
  file: yup
    .mixed<File>()
    .required('Selecione um ficheiro.')
    .test('is-file', 'Selecione um ficheiro válido.', (file) => !!file)
    .test(
      'ext-by-type',
      'Extensão não permitida para este tipo.',
      function (file) {
        const type = this.parent?.type as 'favicon' | 'logo' | 'background';
        const ext = extOf(file);
        if (!file) return false;

        if (type === 'favicon') return isOneOf(ext, ICO_ONLY);
        if (type === 'logo') return isOneOf(ext, LOGO_EXTS);
        if (type === 'background') return isOneOf(ext, BG_EXTS);
        return false;
      }
    )

    .test(
      'max-dimensions',
      'Dimensões acima do permitido.',
      async function (file) {
        const type = this.parent?.type as 'favicon' | 'logo' | 'background';
        if (!file) return false;

     
        const ext = extOf(file);
        if (ext === 'svg') {
          
        }
        try {
             const { width, height } = await readImageSize(file);

        // if (type === 'logo') {
        //   return width <= 512 && height >= 512;
        // }
        // if (type === 'background') {
        //   return width <= 2048 && height >= 1300;
        // }
        } catch (error) {
                    return false;

        }
       
        
        return true;
      }
    ),

  preview: yup.string(),
  uploaded: yup.boolean(),
});
